import { useState } from 'react';
import classnames from 'classnames';
import './index.scss';

const Dropdown = ({
  title,
  description,
  className,
  defaultShow,
  disableToggle,
  label,
  labelFunc,
  children,
  ...props
}) => {
  const [show, setShow] = useState(!!defaultShow);
  return (
    <div
      className={classnames('dropdown', disableToggle && 'disabled', show && 'active', className)}
      {...props}
    >
      <div className="dropdown__header" onClick={() => !disableToggle && setShow(!show)}>
        {label || labelFunc(show) || (
          <span className="f-22 f-500">{title || 'Founders batch'}</span>
        )}

        {!disableToggle && (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 10L12 14L16 10"
              stroke="#323232"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      {description && <p className="dropdown__description f-16 f-400">{description}</p>}
      <div className="dropdown__content">{children}</div>
    </div>
  );
};

export default Dropdown;
